import { render } from "./detail.vue?vue&type=template&id=1651b40d&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=1651b40d&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1651b40d"],['__file',"src/views/food/tag/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1651b40d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1651b40d', __exports__)) {
    console.log('reload')
    api.reload('1651b40d', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=1651b40d&scoped=true", () => {
    console.log('re-render')
    api.rerender('1651b40d', render)
  })

}


export default __exports__